import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { API } from '../App';

const EMOJIS = [
  { emoji: 'fire', label: 'Fire', icon: '🔥' },
  { emoji: 'brain', label: 'Smart', icon: '🧠' },
  { emoji: 'target', label: 'On Point', icon: '🎯' },
  { emoji: 'thinking', label: 'Hmm', icon: '🤔' },
  { emoji: 'disagree', label: 'Disagree', icon: '👎' },
  { emoji: 'boom', label: 'Mic Drop', icon: '💥' },
];

export function ReactionBar({ frayId, voiceId, sequenceId }) {
  const [reacted, setReacted] = useState(null);

  const handleReact = async (emoji) => {
    try {
      await API.post(`/api/frays/${frayId}/reactions`, { voice_id: voiceId, sequence_id: sequenceId, emoji });
      setReacted(emoji);
      setTimeout(() => setReacted(null), 2000);
    } catch {}
  };

  return (
    <div className="flex items-center gap-1 mt-1.5" data-testid={`reactions-${voiceId}`}>
      {EMOJIS.map(e => (
        <button key={e.emoji} onClick={() => handleReact(e.emoji)}
          className={`text-xs px-1.5 py-0.5 rounded transition-all ${reacted === e.emoji ? 'bg-[#FF4D00]/20 scale-110' : 'hover:bg-[#2A2A2A] opacity-40 hover:opacity-100'}`}
          title={e.label}>
          {e.icon}
        </button>
      ))}
    </div>
  );
}

export function ReactionSummary({ reactions, voiceId }) {
  const voiceReactions = (reactions || []).filter(r => r.voice_id === voiceId);
  if (voiceReactions.length === 0) return null;
  return (
    <div className="flex items-center gap-1 mt-1">
      {voiceReactions.map((r, i) => (
        <span key={i} className="text-[10px] px-1.5 py-0.5 bg-[#2A2A2A] rounded-full flex items-center gap-1">
          {EMOJIS.find(e => e.emoji === r.emoji)?.icon || '?'} <span className="text-[#A0A0A0]">{r.count}</span>
        </span>
      ))}
    </div>
  );
}
